import { useStringParam } from '@/hooks/useParam'
import { getArea } from '@/stores/areas'
import { useDispatch, useSelector } from '@/stores/hooks'
import { getStop } from '@/stores/stops'
import { setPopupOpened } from '@/stores/temp'
import { pointToLatlng } from '@lc/libgeo'
import { useOnChange } from '@lc/libreact'
import type { Point } from 'geojson'

export function BindStopPopup({ stop }: { stop?: string }) {
	const [area] = useStringParam('area', '')
	const stopInfo = useSelector(state => {
		if (stop) return getStop(state, stop)
		if (area !== '') return getArea(state, area)
		return null
	})

	const dispatch = useDispatch()
	useOnChange(() => {
		if (stopInfo) {
			dispatch(
				setPopupOpened({
					id: stopInfo.id,
					type: stop ? 'stop_point' : 'stop_area',
					pos: pointToLatlng(stopInfo.geojson as Point),
				}),
			)
		}

		return () => {
			dispatch(setPopupOpened(null))
		}
	}, stopInfo)

	return null
}
